import http from '@/http'

var BASE_URL = '/admin/participant-cards'
var URL_REGISTRATION_CONTROLS = '/admin/registration-controls'

export default {
  // Cards
  getCards: function (params) {
    if (!params) params = {}
    return http.get(BASE_URL, { params: params })
  },

  getCard: function (id) {
    return http.get(BASE_URL + '/' + id)
  },

  getGlobalCard: function () {
    return http.get(BASE_URL + '/global')
  },

  getActiveCardForGroup: function (groupId) {
    return http.get(BASE_URL + '/active-for-group/' + groupId)
  },

  getCardForParticipant: function (participantId) {
    return http.get(BASE_URL + '/for-participant/' + participantId)
  },

  createCard: function (data) {
    return http.post(BASE_URL, data)
  },

  updateCard: function (id, data) {
    return http.put(BASE_URL + '/' + id, data)
  },

  toggleStatus: function (id) {
    return http.patch(BASE_URL + '/' + id + '/toggle-status')
  },

  duplicateCard: function (id) {
    return http.post(BASE_URL + '/' + id + '/duplicate')
  },

  deleteCard: function (id) {
    return http.delete(BASE_URL + '/' + id)
  },

  // Tabs
  getTabs: function (cardId) {
    return http.get(BASE_URL + '/' + cardId + '/tabs')
  },

  createTab: function (cardId, data) {
    return http.post(BASE_URL + '/' + cardId + '/tabs', data)
  },

  updateTab: function (cardId, tabId, data) {
    return http.put(BASE_URL + '/' + cardId + '/tabs/' + tabId, data)
  },

  reorderTabs: function (cardId, tabs) {
    return http.patch(BASE_URL + '/' + cardId + '/tabs/reorder', { tabs: tabs })
  },

  deleteTab: function (cardId, tabId) {
    return http.delete(BASE_URL + '/' + cardId + '/tabs/' + tabId)
  },

  // Fields
  getFields: function (cardId, tabId) {
    return http.get(BASE_URL + '/' + cardId + '/tabs/' + tabId + '/fields')
  },

  getAvailableFields: function () {
    return http.get(BASE_URL + '/fields/available')
  },

  createField: function (cardId, tabId, data) {
    return http.post(BASE_URL + '/' + cardId + '/tabs/' + tabId + '/fields', data)
  },

  updateField: function (cardId, tabId, fieldId, data) {
    return http.put(BASE_URL + '/' + cardId + '/tabs/' + tabId + '/fields/' + fieldId, data)
  },

  reorderFields: function (cardId, tabId, fields) {
    return http.patch(BASE_URL + '/' + cardId + '/tabs/' + tabId + '/fields/reorder', { fields: fields })
  },

  moveField: function (cardId, tabId, fieldId, data) {
    return http.patch(BASE_URL + '/' + cardId + '/tabs/' + tabId + '/fields/' + fieldId + '/move', data)
  },

  deleteField: function (cardId, tabId, fieldId) {
    return http.delete(BASE_URL + '/' + cardId + '/tabs/' + tabId + '/fields/' + fieldId)
  },

  // Auto Organize
  autoOrganize: function (cardId, data) {
    return http.post(BASE_URL + '/' + cardId + '/auto-organize', data)
  },

  // Registration Control fields
  getRegistrationControlFields: function (controlId) {
    return http.get(URL_REGISTRATION_CONTROLS + '/' + controlId + '/form-builder-fields')
  }
}
